import { Icon } from '@chakra-ui/react';
import React from 'react';

const DownArrow = () => (
  <Icon
    width="15px"
    height="7px"
    viewBox="0 0 17 8"
    ml="space.2xs"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    transition=".3s transform"
  >
    <path
      id="Vector 1"
      d="M1 0.5L7.13536 6.22634C7.90378 6.94353 9.09622 6.94353 9.86464 6.22634L16 0.5"
      stroke="#232528"
      strokeLinecap="round"
    />
  </Icon>
);

export default DownArrow;
